import type React from 'react'
import { useEffect, useState } from 'react'
import { useUser } from '../contexts/UserContext'
import { type TruckResponse, truckService } from '../services/truckService'
import CardRow from './card/CardRow'

const TruckInfo: React.FC = () => {
  const [truck, setTruck] = useState<TruckResponse | null>(null)
  const { user } = useUser()

  useEffect(() => {
    const fetchTruck = async () => {
      try {
        if (user) {
          const trucks = await truckService.getUserVehicles(user.id)
          if (trucks && trucks.length > 0) {
            setTruck(trucks[0])
          }
        }
      } catch (error) {
        console.error('Failed to fetch truck info:', error)
      }
    }

    fetchTruck()
  }, [user])

  if (!truck) return null

  return (
    <>
      <CardRow label="TRUCK NUMBER" value={truck.truck_number} vertical />
      <CardRow label="TRUCK TYPE" value={truck.truck_type} vertical />
      <CardRow label="LICENSE #" value={truck.license_number} vertical />
    </>
  )
}

export default TruckInfo
